/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Error_GenericInputs */

const vi_customer_error_generic = /** @type {(inputs: Customer_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có lỗi xảy ra`)
};

/**

* @param {Customer_Error_GenericInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_error_generic = /** @type {((inputs?: Customer_Error_GenericInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Error_GenericInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_error_generic(inputs)
});